import { EventsDesktopView } from './EventsDesktopView';

export function EventsMobileView() {
  return <EventsDesktopView />;
}
